export default __webpack_public_path__ + "static/media/tn-ventas-01-EN.915612b5.jpg";